import * as React from 'react';
import { generatePath, useHistory } from 'react-router';

import appUrls from 'base/app/urls';
import { PK } from 'common/types';

import { fields, IngredientsFields } from './consts';
import { useIngredientsCreate, useIngredientsUpdate } from './queries';

export const useSave = (pk?: PK) => {
  const [created, setCreated] = React.useState(pk);
  const create = useIngredientsCreate();
  const update = useIngredientsUpdate();
  const history = useHistory();

  const isSaving = create.isLoading || update.isLoading;
  const error = create.error || update.error;

  const save = (values: IngredientsFields) => {
    const payload = {
      name_singular: values[fields.name_singular.name],
      name_plural: values[fields.name_plural.name],
      category_pk: values[fields.category.name][0].value,
      unit_pk: values[fields.unit.name]?.[0].value ?? null,
    };

    if (created) {
      update.mutate({
        ...payload,
        pk: created,
      });
    } else {
      create.mutate(payload, {
        onSuccess: ({ pk }) => {
          setCreated(pk);
          history.push(generatePath(appUrls.INGREDIENTS.DETAILS, { pk }));
        },
      });
    }
  };

  return { save, created, isSaving, error };
};
